export function createPdfFileName(prefix = 'FarmCreditReport') {
  const now = new Date();

  const pad = (value: number) => String(value).padStart(2, '0');

  const timestamp =
    `${now.getFullYear()}-` +
    `${pad(now.getMonth() + 1)}-` +
    `${pad(now.getDate())}_` +
    `${pad(now.getHours())}-` +
    `${pad(now.getMinutes())}-` +
    `${pad(now.getSeconds())}`;

  return `${prefix}_${timestamp}.pdf`;
}
